
export default {
  props: {
    price: [Number, String],
    price_old: [Number, String]
  },

  computed: {
    discountPercentage() {
      const current = Number(this.price);
      const old = Number(this.price_old);

      if (!old || old <= current || isNaN(current) || isNaN(old)) {
        return 0;
      }

      const diff = old - current;
      const percent = (diff / old) * 100;

      return Math.round(percent);
    }
  }
}
